import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import { categoriesState } from '../constants/initial-state';

export default function downloadsReducer(state = categoriesState, action: IAction) {
    switch (action.type) {
        case (types.CATEGORIES_REQUESTED):
            return Object.assign({}, state, { isFetching: true });
        case (types.CATEGORIES_RETRIEVED):
            const data = action.data instanceof Array ? action.data : [];
            return Object.assign({}, state, { isFetching: false, loaded: true, items: data, total: data.length });
        case (types.CATEGORIES_FAILED):
            return Object.assign({}, state, { isFetching: false, error: action.data });
        case (types.CATEGORIES_CHANGE_PAGE):
            return Object.assign({}, state, { page: action.data });
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/categories.reducer.ts